import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace, clearSearch} from '../actions/race';
import Loading from './Loading';
import PlayIcon from '../icons/play';

class MobileResults extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {
    division: null,
    eventId: null
  };

  componentDidMount() {

    this.props.syncFavorites(this.props.match.params.raceId);
    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
    }

    this.props.clearSearch();
  }

  componentWillUpdate(newProps){

    if (this.props.match.params.raceId !== newProps.match.params.raceId) {
      this.props.switchRace(newProps.match.params.raceId);
      this.setState({search: '', hasSearched: false});
    }

    if (this.props.match.params.eventId !== newProps.match.params.eventId) {
      this.props.selectEvent(newProps.match.params.eventId);
    }

    this.props.clearSearch();
  }

  render() {

    const {raceDetail} = this.props;

    if (!raceDetail || !raceDetail.name) return null;

    const eventOptions = [];
    this.props.raceDetail.event_mapping.map((div) => {
      eventOptions.push({value: div.key, label: div.name.toUpperCase()});
    });

    let divs = this.props.raceDetail.divisions;
    if (this.props.raceDetail.event_metadata[this.props.eventId] && this.props.raceDetail.event_metadata[this.props.eventId].divisions) {
      divs = this.props.raceDetail.event_metadata[this.props.eventId].divisions;
    }

    const ColorThemeA = styled.a`
      {
        color: ${this.props.color} !important;
        background: ${this.props.backgroundColor} !important;
      }
    `;

    return (
      <div>
        <div className="header">
          <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

          <div className="info-block clearfix">
            <h3>Filter</h3>

            <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
          </div>
        </div>

        {this.props.raceDetail.txt_results && this.props.raceDetail.txt_results[this.props.eventId] ?
          (
        <div id="wrapper">
          <div id="text-results" style={{minWidth :"500px"}}>
            <pre>{this.props.raceDetail.txt_results[this.props.eventId]}</pre>
          </div>
        </div>
          ) : (
        <div className="menu" id="filter-results">
          <ul>
            <li>
              <ColorThemeA href="#">Choose a Division</ColorThemeA>
              <div className="sub-menu">
                {eventOptions.length > 0 && !this.props.match.params.eventId ?
                  (
                    <ul id="filter-events">

                      {eventOptions.map((event, idx) => (
                        <li key={idx}><a href={`#/race/${raceDetail.race_id}/${event.value}/results`} className="division" data-isevent="true">
                          <PlayIcon />
                          <span>{event.label}</span></a></li>
                      ))}

                    </ul>
                  ) : (

                    <ul id="filter-divisions">
                    {
                      divs.map((div, idx) => (
                        <li key={idx}><a href={`#/race/${raceDetail.race_id}/${this.props.match.params.eventId || ''}/results/${div}`} className="division" data-isevent="true">
                          <PlayIcon />
                          <span>{div.toUpperCase()}</span></a></li>
                      ))
                    }
                </ul>
                  )}
              </div>
            </li>
          </ul>
        </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId,
    color: state.rr360.theme.primaryColor,
    backgroundColor: state.rr360.secondaryColor
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace, clearSearch})(MobileResults);



// WEBPACK FOOTER //
// ./src/components/MobileResults.js